import { ApiDealerInfo, DealerInfo } from "./types";

export const parseAPIDealerInfo = (apiDealerInfo: ApiDealerInfo): DealerInfo => {
     return{
            id: apiDealerInfo.id,
            name: apiDealerInfo.dealerName,
            adress: apiDealerInfo.adress,
            state:apiDealerInfo.state,
            city: apiDealerInfo.city,
            zipcode: apiDealerInfo.zipcode,
            phone:apiDealerInfo.displayPhone,
            url:apiDealerInfo.displayUrl,
            cms:apiDealerInfo.cmsUrl,
            infoHours: apiDealerInfo.infoHours

        }    

}